<template>
  <div>
     <div class="title-dialog">
      <p style="font-size: 30px; font-family: Roboto; font-weight: 100;">{{$t('delete_account')}}</p>
    </div>
      
    <div class="icon-close">
      <b-icon stacked icon="x" @click="closeDialog()" scale="1.1" class="style-x" v-b-tooltip.hover title="Fechar" ></b-icon>
    </div>

    <div class="wrapper-deleteAccount">
      
      <div>
        <b-form>
            <b-form-checkbox
              id="checkbox-1"
              v-model="deleteAccountOk"
              name="checkbox-1"
              value="accepted"
              unchecked-value="not_accepted"
            >
              Desejo realmente excluir minha conta.
            </b-form-checkbox>
        

          <div style="margin-top:25px" class="d-flex flex-row-reverse">
            <b-button @click="deleteAccount()" class="btn_atos-submit btn_log_in" :disabled="enableButtonDeleteAccount">
              {{$t('btn_delete_account')}}
              <b-spinner  v-if="showSpinner" variant="light" small></b-spinner>
            </b-button>
          </div>

        </b-form>
      </div>
        
    </div>

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import firebase from '@/firebaseInit.js';
import i18n from '@/i18n.js'

export default {
  name: 'Login',
  props: ['origin'],
  components: {

  },
   data: () => ({
   
    deleteAccountOk : false,
    showSpinner: false,
    enableButtonDeleteAccount: true,
    refUsers: firebase.firestore().collection('users'),
  }),

     computed: {
      ...mapGetters({
          user : "user",
          keywordsAlerts : "keywordsAlerts"
      })
    },

  methods: {
    deleteAccount: function(){

          this.refUsers.doc(this.user.data.id).delete().then(()=>  {
            firebase.auth().currentUser.delete().then(()=> {
              this.$bvModal.msgBoxOk(i18n.t('message_successfully_delete_acccount'), {
                title: i18n.t('msgTitleWarning'),
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'success',
                headerClass: 'p-2 border-bottom-0',
                footerClass: 'p-2 border-top-0',
                centered: true
              }).then(()=>{
                this.$emit('showDialogDeleteAccount', false )
              })
            }).catch(()=> {
                this.$bvModal.msgBoxOk(i18n.t('message_error_delete_acccount'), {
                  title: i18n.t('msgTitleWarning'),
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'error',
                  headerClass: 'p-2 border-bottom-0',
                  footerClass: 'p-2 border-top-0',
                  centered: true
                })
              });
            }).catch(()=>{
              this.$bvModal.msgBoxOk(i18n.t('message_error_delete_acccount'), {
                title: i18n.t('msgTitleWarning'),
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'error',
                headerClass: 'p-2 border-bottom-0',
                footerClass: 'p-2 border-top-0',
                centered: true
              })
            });



         

        

       
    },
    closeDialog(){
      this.showDialog = false;
      this.$emit('showDialogDeleteAccount', false )
    }
  },
  watch:{
    deleteAccountOk: function () {
      this.enableButtonDeleteAccount =  !this.enableButtonDeleteAccount
    }
  }
}
</script>

<style lang="scss" scoped>

.wrapper-deleteAccount{
  color: #fff;
  width: 435px;
  padding: 50px 20px 20px 20px;
}
 



</style>
